import React from 'react';

import { Select, SelectItem } from '@zapier/design-system';

import { REQUEST_METHODS } from 'app/developer-v3/constants';

import { RequestMethodTypes } from 'app/developer-v3/types/request';

type Props = {
  onChange: (options: RequestMethodTypes) => void;
  defaultValue: RequestMethodTypes;
};

function RequestMethodPicker({ onChange, defaultValue }: Props) {
  return (
    <Select
      label="Request method"
      isLabelHidden
      defaultSelectedKey={defaultValue ?? null}
      onChange={key => onChange(key as RequestMethodTypes)}
      size="large"
    >
      {REQUEST_METHODS.map(method => (
        <SelectItem key={method.value} value={method.value}>
          {method.label}
        </SelectItem>
      ))}
    </Select>
  );
}

export default RequestMethodPicker;
